import ApiService from "@/common/general-api";
import JwtService from "@/common/general-jwt";



/** ----------------------------------------------------
 * State => Holds all data we need
 ----------------------------------------------------- */
const state = {
    
    widget_satisfaction: false
	
};



/** ----------------------------------------------------
 * Mutations => Updates data in State
 ----------------------------------------------------- */
const mutations = {

    // set satisfaction
    WIDGET_SET_SATISFACTION( state, data ) { state.widget_satisfaction = data; },

};



/** ----------------------------------------------------
 * Actions => Proccess and fetch data
 ----------------------------------------------------- */
const actions = {

    /**
	 * Set satisfaction
	 * @param {*} query
	 */
    widget_satisfaction_set( context, vote_data ) {

        // call api to get feedback items
		return new Promise( function(resolve, reject) {

            // update feedback via api
            ApiService.post('feedback/' + context.getters.product_active_id + '/satisfaction/', vote_data, function( data ) {

                // unset user login form
                context.commit('WIDGET_SET_SATISFACTION', {vote: vote_data.vote}); 

                // set success
                return resolve(data);

            }, function( data ) {

                // set rejection
                return reject(data);

            });

        });
        
    },

    /**
	 * Get satisfaction
	 * @param {*} query
	 */
    widget_satisfaction_get( context ) {

        // call api to get single feedback item
		return new Promise( function(resolve, reject) { 

            // if not logged in stop here
            if( ! context.getters.user_data ) return reject();
            
            // load data via API
            ApiService.get('feedback/' + context.getters.product_active_id + '/satisfaction', '', function( data ) {

                // unset user login form
                context.commit('WIDGET_SET_SATISFACTION', data); 

                // set success
                return resolve(data);

            }, function( data ) {

                // set rejection
                return reject(data);

            });

        });
        
    }

};



/** ----------------------------------------------------
 * Getters => Access data from outside
 ----------------------------------------------------- */
const getters = {

	// get satisfaction vote
	widget_satisfaction(state) {
		return state.widget_satisfaction;
    },
	
};



/***********************
 * Export
***********************/

export default {
	state,
	getters,
	actions,
	mutations
};